import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, forwardRef, Component, Input, Output, HostBinding, ViewChild } from '@angular/core';
import * as i2 from '@angular/forms';
import { FormControl, Validators, NG_VALUE_ACCESSOR, NG_VALIDATORS, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import * as i3 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { AngularFormsMaskDirective } from 'angular-forms-input-mask-iiko';
const _c0 = ["phone"];
const masksByTimezones = {
  'Africa/Abidjan': ['+225-DD-DDD-DDD', '+226-DD-DD-DDDD', '+233(DDD)DDD-DDD', '+220(DDD)DD-DD', '+224-DD-DDD-DDD', '+223-DD-DD-DDDD', '+222-DD-DD-DDDD', '+290-DDDD', '+290-DDDD', '+232-DD-DDDDDD', '+221-DD-DDD-DDDD', '+228-DD-DDD-DDD'],
  'Africa/Accra': ['+233(DDD)DDD-DDD'],
  'Africa/Addis_Ababa': ['+251-DD-DDD-DDDD'],
  'Africa/Algiers': ['+213-DD-DDD-DDDD'],
  'Africa/Asmara': ['+291-D-DDD-DDD'],
  'Africa/Asmera': ['+291-D-DDD-DDD'],
  'Africa/Bamako': ['+223-DD-DD-DDDD'],
  'Africa/Bangui': ['+236-DD-DD-DDDD'],
  'Africa/Banjul': ['+220(DDD)DD-DD'],
  'Africa/Bissau': ['+245-D-DDDDDD'],
  'Africa/Blantyre': ['+265-1-DDD-DDD', '+265-D-DDDD-DDDD'],
  'Africa/Brazzaville': ['+242-DD-DDD-DDDD'],
  'Africa/Bujumbura': ['+257-DD-DD-DDDD'],
  'Africa/Cairo': ['+20(DDD)DDD-DDDD'],
  'Africa/Casablanca': ['+212-DD-DDDD-DDD'],
  'Africa/Ceuta': ['+34(DDD)DDD-DDD'],
  'Africa/Conakry': ['+224-DD-DDD-DDD'],
  'Africa/Dakar': ['+221-DD-DDD-DDDD'],
  'Africa/Dar_es_Salaam': ['+255-DD-DDD-DDDD'],
  'Africa/Djibouti': ['+253-DD-DD-DD-DD'],
  'Africa/Douala': ['+237-DDDD-DDDD'],
  'Africa/Freetown': ['+232-DD-DDDDDD'],
  'Africa/Gaborone': ['+267-DD-DDD-DDD'],
  'Africa/Harare': ['+263-D-DDDDDD'],
  'Africa/Johannesburg': ['+27-DD-DDD-DDDD', '+266-D-DDD-DDDD', '+268-DD-DD-DDDD'],
  'Africa/Juba': ['+211-DD-DDD-DDDD'],
  'Africa/Kampala': ['+256(DDD)DDD-DDD'],
  'Africa/Khartoum': ['+249-DD-DDD-DDDD'],
  'Africa/Kigali': ['+250(DDD)DDD-DDD'],
  'Africa/Kinshasa': ['+243(DDD)DDD-DDD'],
  'Africa/Lagos': ['+234(DDD)DDD-DDDD', '+234-DD-DDD-DDD', '+234-DD-DDD-DD', '+234(DDD)DDD-DDDD', '+244(DDD)DDD-DDD', '+229-DD-DD-DDDD', '+243(DDD)DDD-DDD', '+236-DD-DD-DDDD', '+242-DD-DDD-DDDD', '+237-DDDD-DDDD', '+241-D-DD-DD-DD', '+240-DD-DDD-DDDD', '+227-DD-DD-DDDD'],
  'Africa/Libreville': ['+241-D-DD-DD-DD'],
  'Africa/Lome': ['+228-DD-DDD-DDD'],
  'Africa/Luanda': ['+244(DDD)DDD-DDD'],
  'Africa/Lubumbashi': ['+243(DDD)DDD-DDD'],
  'Africa/Lusaka': ['+260-DD-DDD-DDDD'],
  'Africa/Malabo': ['+240-DD-DDD-DDDD'],
  'Africa/Maputo': ['+258-DD-DDD-DDD', '+257-DD-DD-DDDD', '+267-DD-DDD-DDD', '+243(DDD)DDD-DDD', '+265-1-DDD-DDD', '+265-D-DDDD-DDDD', '+250(DDD)DDD-DDD', '+260-DD-DDD-DDDD', '+263-D-DDDDDD'],
  'Africa/Maseru': ['+266-D-DDD-DDDD'],
  'Africa/Mbabane': ['+268-DD-DD-DDDD'],
  'Africa/Mogadishu': ['+252-DD-DDD-DDD', '+252-D-DDD-DDD', '+252-D-DDD-DDD'],
  'Africa/Monrovia': ['+231-DD-DDD-DDD'],
  'Africa/Nairobi': ['+254-DDD-DDDDDD', '+253-DD-DD-DD-DD', '+291-D-DDD-DDD', '+251-DD-DDD-DDDD', '+269-DD-DDDDD', '+261-DD-DD-DDDDD', '+252-DD-DDD-DDD', '+252-D-DDD-DDD', '+252-D-DDD-DDD', '+255-DD-DDD-DDDD', '+256(DDD)DDD-DDD'],
  'Africa/Ndjamena': ['+235-DD-DD-DD-DD'],
  'Africa/Niamey': ['+227-DD-DD-DDDD'],
  'Africa/Nouakchott': ['+222-DD-DD-DDDD'],
  'Africa/Ouagadougou': ['+226-DD-DD-DDDD'],
  'Africa/Porto-Novo': ['+229-DD-DD-DDDD'],
  'Africa/Sao_Tome': ['+239-DD-DDDDD'],
  'Africa/Timbuktu': ['+223-DD-DD-DDDD'],
  'Africa/Tripoli': ['+218-DD-DDD-DDD', '+218-21-DDD-DDDD'],
  'Africa/Tunis': ['+216-DD-DDD-DDD'],
  'Africa/Windhoek': ['+264-DD-DDD-DDDD'],
  'America/Adak': ['+1(DDD)DDD-DDDD'],
  'America/Anchorage': ['+1(DDD)DDD-DDDD'],
  'America/Anguilla': ['+1(264)DDD-DDDD'],
  'America/Antigua': ['+1(268)DDD-DDDD'],
  'America/Araguaina': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Argentina/Buenos_Aires': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/Catamarca': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/Cordoba': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/Jujuy': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/La_Rioja': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/Mendoza': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/Rio_Gallegos': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/Salta': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/San_Juan': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/San_Luis': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/Tucuman': ['+54(DDD)DDD-DDDD'],
  'America/Argentina/Ushuaia': ['+54(DDD)DDD-DDDD'],
  'America/Aruba': ['+297-DDD-DDDD'],
  'America/Asuncion': ['+595(DDD)DDD-DDD'],
  'America/Atikokan': ['+1(DDD)DDD-DDDD'],
  'America/Bahia': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Bahia_Banderas': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Barbados': ['+1(246)DDD-DDDD'],
  'America/Belem': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Belize': ['+501-DDD-DDDD'],
  'America/Blanc-Sablon': ['+1(DDD)DDD-DDDD'],
  'America/Boa_Vista': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Bogota': ['+57(DDD)DDD-DDDD'],
  'America/Boise': ['+1(DDD)DDD-DDDD'],
  'America/Cambridge_Bay': ['+1(DDD)DDD-DDDD'],
  'America/Campo_Grande': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Cancun': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Caracas': ['+58(DDD)DDD-DDDD'],
  'America/Cayenne': ['+594-DDDDD-DDDD'],
  'America/Cayman': ['+1(345)DDD-DDDD'],
  'America/Chicago': ['+1(DDD)DDD-DDDD'],
  'America/Chihuahua': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Coral_Harbour': ['+1(DDD)DDD-DDDD'],
  'America/Costa_Rica': ['+506-DDDD-DDDD'],
  'America/Creston': ['+1(DDD)DDD-DDDD'],
  'America/Cuiaba': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Curacao': ['+599-DDD-DDDD'],
  'America/Danmarkshavn': ['+299-DD-DD-DD'],
  'America/Dawson': ['+1(DDD)DDD-DDDD'],
  'America/Dawson_Creek': ['+1(DDD)DDD-DDDD'],
  'America/Denver': ['+1(DDD)DDD-DDDD'],
  'America/Detroit': ['+1(DDD)DDD-DDDD'],
  'America/Dominica': ['+1(767)DDD-DDDD'],
  'America/Edmonton': ['+1(DDD)DDD-DDDD'],
  'America/Eirunepe': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/El_Salvador': ['+503-DD-DD-DDDD'],
  'America/Fort_Nelson': ['+1(DDD)DDD-DDDD'],
  'America/Fortaleza': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Glace_Bay': ['+1(DDD)DDD-DDDD'],
  'America/Goose_Bay': ['+1(DDD)DDD-DDDD'],
  'America/Grand_Turk': ['+1(649)DDD-DDDD'],
  'America/Grenada': ['+1(473)DDD-DDDD'],
  'America/Guatemala': ['+502-D-DDD-DDDD'],
  'America/Guayaquil': ['+593-DD-DDD-DDDD', '+593-D-DDD-DDDD'],
  'America/Guyana': ['+592-DDD-DDDD'],
  'America/Halifax': ['+1(DDD)DDD-DDDD'],
  'America/Havana': ['+53-D-DDD-DDDD'],
  'America/Hermosillo': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Indiana/Indianapolis': ['+1(DDD)DDD-DDDD'],
  'America/Indiana/Knox': ['+1(DDD)DDD-DDDD'],
  'America/Indiana/Marengo': ['+1(DDD)DDD-DDDD'],
  'America/Indiana/Petersburg': ['+1(DDD)DDD-DDDD'],
  'America/Indiana/Tell_City': ['+1(DDD)DDD-DDDD'],
  'America/Indiana/Vevay': ['+1(DDD)DDD-DDDD'],
  'America/Indiana/Vincennes': ['+1(DDD)DDD-DDDD'],
  'America/Indiana/Winamac': ['+1(DDD)DDD-DDDD'],
  'America/Inuvik': ['+1(DDD)DDD-DDDD'],
  'America/Iqaluit': ['+1(DDD)DDD-DDDD'],
  'America/Jamaica': ['+1(876)DDD-DDDD'],
  'America/Juneau': ['+1(DDD)DDD-DDDD'],
  'America/Kentucky/Louisville': ['+1(DDD)DDD-DDDD'],
  'America/Kentucky/Monticello': ['+1(DDD)DDD-DDDD'],
  'America/La_Paz': ['+591-D-DDD-DDDD'],
  'America/Lima': ['+51(DDD)DDD-DDD'],
  'America/Los_Angeles': ['+1(DDD)DDD-DDDD'],
  'America/Lower_Princes': ['+1(721)DDD-DDDD'],
  'America/Maceio': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Managua': ['+505-DDDD-DDDD'],
  'America/Manaus': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Martinique': ['+596(DDD)DD-DD-DD'],
  'America/Matamoros': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Mazatlan': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Menominee': ['+1(DDD)DDD-DDDD'],
  'America/Merida': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Metlakatla': ['+1(DDD)DDD-DDDD'],
  'America/Mexico_City': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Moncton': ['+1(DDD)DDD-DDDD'],
  'America/Monterrey': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Montevideo': ['+598-D-DDD-DD-DD'],
  'America/Montreal': ['+1(DDD)DDD-DDDD'],
  'America/Montserrat': ['+1(664)DDD-DDDD'],
  'America/Nassau': ['+1(242)DDD-DDDD'],
  'America/New_York': ['+1(DDD)DDD-DDDD'],
  'America/Nipigon': ['+1(DDD)DDD-DDDD'],
  'America/Nome': ['+1(DDD)DDD-DDDD'],
  'America/Noronha': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/North_Dakota/Beulah': ['+1(DDD)DDD-DDDD'],
  'America/North_Dakota/Center': ['+1(DDD)DDD-DDDD'],
  'America/North_Dakota/New_Salem': ['+1(DDD)DDD-DDDD'],
  'America/Nuuk': ['+299-DD-DD-DD'],
  'America/Ojinaga': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Panama': ['+507-DDD-DDDD', '+1(DDD)DDD-DDDD', '+1(345)DDD-DDDD'],
  'America/Pangnirtung': ['+1(DDD)DDD-DDDD'],
  'America/Paramaribo': ['+597-DDD-DDDD', '+597-DDD-DDD'],
  'America/Phoenix': ['+1(DDD)DDD-DDDD', '+1(DDD)DDD-DDDD'],
  'America/Port-au-Prince': ['+509-DD-DD-DDDD'],
  'America/Port_of_Spain': ['+1(868)DDD-DDDD'],
  'America/Porto_Velho': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Puerto_Rico': ['+1(268)DDD-DDDD', '+1(DDD)DDD-DDDD', '+1(264)DDD-DDDD', '+297-DDD-DDDD', '+599-DDD-DDDD', '+1(767)DDD-DDDD', '+1(473)DDD-DDDD', '+1(869)DDD-DDDD', '+1(758)DDD-DDDD', '+1(664)DDD-DDDD', '+1(721)DDD-DDDD', '+1(868)DDD-DDDD', '+1(784)DDD-DDDD', '+1(284)DDD-DDDD', '+1(340)DDD-DDDD'],
  'America/Punta_Arenas': ['+56-D-DDDD-DDDD'],
  'America/Rainy_River': ['+1(DDD)DDD-DDDD'],
  'America/Rankin_Inlet': ['+1(DDD)DDD-DDDD'],
  'America/Recife': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Regina': ['+1(DDD)DDD-DDDD'],
  'America/Resolute': ['+1(DDD)DDD-DDDD'],
  'America/Rio_Branco': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Santarem': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Santiago': ['+56-D-DDDD-DDDD'],
  'America/Santo_Domingo': ['+1(809)DDD-DDDD', '+1(829)DDD-DDDD', '+1(849)DDD-DDDD'],
  'America/Sao_Paulo': ['+55(DD)DDDD-DDDD', '+55(DD)7DDD-DDDD', '+55(DD)9DDDD-DDDD'],
  'America/Scoresbysund': ['+299-DD-DD-DD'],
  'America/Sitka': ['+1(DDD)DDD-DDDD'],
  'America/St_Johns': ['+1(DDD)DDD-DDDD'],
  'America/St_Kitts': ['+1(869)DDD-DDDD'],
  'America/St_Lucia': ['+1(758)DDD-DDDD'],
  'America/St_Thomas': ['+1(340)DDD-DDDD'],
  'America/St_Vincent': ['+1(784)DDD-DDDD'],
  'America/Swift_Current': ['+1(DDD)DDD-DDDD'],
  'America/Tegucigalpa': ['+504-DDDD-DDDD'],
  'America/Thule': ['+299-DD-DD-DD'],
  'America/Thunder_Bay': ['+1(DDD)DDD-DDDD'],
  'America/Tijuana': ['+52(DDD)DDD-DDDD', '+52-DD-DD-DDDD'],
  'America/Toronto': ['+1(DDD)DDD-DDDD', '+1(242)DDD-DDDD'],
  'America/Tortola': ['+1(284)DDD-DDDD'],
  'America/Vancouver': ['+1(DDD)DDD-DDDD'],
  'America/Virgin': ['+1(340)DDD-DDDD'],
  'America/Whitehorse': ['+1(DDD)DDD-DDDD'],
  'America/Winnipeg': ['+1(DDD)DDD-DDDD'],
  'America/Yakutat': ['+1(DDD)DDD-DDDD'],
  'America/Yellowknife': ['+1(DDD)DDD-DDDD'],
  'Antarctica/Casey': ['+672-1DD-DDD'],
  'Antarctica/Davis': ['+672-1DD-DDD'],
  'Antarctica/DumontDUrville': ['+672-1DD-DDD'],
  'Antarctica/Macquarie': ['+61-D-DDDD-DDDD'],
  'Antarctica/Mawson': ['+672-1DD-DDD'],
  'Antarctica/McMurdo': ['+672-1DD-DDD'],
  'Antarctica/Palmer': ['+672-1DD-DDD'],
  'Antarctica/Rothera': ['+672-1DD-DDD'],
  'Antarctica/South_Pole': ['+672-1DD-DDD'],
  'Antarctica/Syowa': ['+672-1DD-DDD'],
  'Antarctica/Troll': ['+672-1DD-DDD'],
  'Antarctica/Vostok': ['+672-1DD-DDD'],
  'Asia/Aden': ['+967-DDD-DDD-DDD', '+967-D-DDD-DDD', '+967-DD-DDD-DDD'],
  'Asia/Almaty': ['+7(6DD)DDD-DD-DD', '+7(7DD)DDD-DD-DD'],
  'Asia/Amman': ['+962-D-DDDD-DDDD'],
  'Asia/Anadyr': ['+7(DDD)DDD-DD-DD'],
  'Asia/Aqtau': ['+7(6DD)DDD-DD-DD', '+7(7DD)DDD-DD-DD'],
  'Asia/Aqtobe': ['+7(6DD)DDD-DD-DD', '+7(7DD)DDD-DD-DD'],
  'Asia/Ashgabat': ['+993-D-DDD-DDDD'],
  'Asia/Atyrau': ['+7(6DD)DDD-DD-DD', '+7(7DD)DDD-DD-DD'],
  'Asia/Baghdad': ['+964(DDD)DDD-DDDD'],
  'Asia/Bahrain': ['+973-DDDD-DDDD'],
  'Asia/Baku': ['+994-DD-DDD-DD-DD'],
  'Asia/Bangkok': ['+66-DD-DDD-DDDD', '+66-DD-DDD-DDD', '+855-DD-DDD-DDD', '+856(20DD)DDD-DDD', '+856-DD-DDD-DDD', '+84-DD-DDDD-DDD', '+84(DDD)DDDD-DDD'],
  'Asia/Barnaul': ['+7(DDD)DDD-DD-DD'],
  'Asia/Beirut': ['+961-DD-DDD-DDD', '+961-D-DDD-DDD'],
  'Asia/Bishkek': ['+996(DDD)DDD-DDD'],
  'Asia/Brunei': ['+673-DDD-DDDD'],
  'Asia/Chita': ['+7(DDD)DDD-DD-DD'],
  'Asia/Choibalsan': ['+976-DD-DD-DDDD'],
  'Asia/Colombo': ['+94-DD-DDD-DDDD'],
  'Asia/Damascus': ['+963-DD-DDDD-DDD'],
  'Asia/Dhaka': ['+880-DD-DDD-DDD'],
  'Asia/Dili': ['+670-DDD-DDDD', '+670-77D-DDDDD', '+670-78D-DDDDD'],
  'Asia/Dubai': ['+971-D-DDD-DDDD', '+971-5D-DDD-DDDD', '+968-DD-DDD-DDD'],
  'Asia/Dushanbe': ['+992-DD-DDD-DDDD'],
  'Asia/Famagusta': ['+357-DD-DDD-DDD'],
  'Asia/Gaza': ['+970-DD-DDD-DDDD'],
  'Asia/Hebron': ['+970-DD-DDD-DDDD'],
  'Asia/Ho_Chi_Minh': ['+84-DD-DDDD-DDD', '+84(DDD)DDDD-DDD'],
  'Asia/Hong_Kong': ['+852-DDDD-DDDD'],
  'Asia/Hovd': ['+976-DD-DD-DDDD'],
  'Asia/Irkutsk': ['+7(DDD)DDD-DD-DD'],
  'Asia/Jakarta': ['+62(8DD)DDD-DDDD', '+62-DD-DDD-DD', '+62-DD-DDD-DDD', '+62-DD-DDD-DDDD', '+62(8DD)DDD-DDD', '+62(8DD)DDD-DD-DDD'],
  'Asia/Jayapura': ['+62(8DD)DDD-DDDD', '+62-DD-DDD-DD', '+62-DD-DDD-DDD', '+62-DD-DDD-DDDD', '+62(8DD)DDD-DDD', '+62(8DD)DDD-DD-DDD'],
  'Asia/Jerusalem': ['+972-5D-DDD-DDDD', '+972-D-DDD-DDDD'],
  'Asia/Kabul': ['+93-DD-DDD-DDDD'],
  'Asia/Kamchatka': ['+7(DDD)DDD-DD-DD'],
  'Asia/Karachi': ['+92(DDD)DDD-DDDD'],
  'Asia/Kathmandu': ['+977-DD-DDD-DDD'],
  'Asia/Khandyga': ['+7(DDD)DDD-DD-DD'],
  'Asia/Kolkata': ['+91(DD)DDD-DDD'],
  'Asia/Krasnoyarsk': ['+7(DDD)DDD-DD-DD'],
  'Asia/Kuala_Lumpur': ['+60-DD-DDD-DDDD', '+60(DDD)DDD-DDD', '+60-DD-DDD-DDD', '+60-D-DDD-DDD'],
  'Asia/Kuching': ['+60-DD-DDD-DDDD', '+60(DDD)DDD-DDD', '+60-DD-DDD-DDD', '+60-D-DDD-DDD'],
  'Asia/Kuwait': ['+965-DDDD-DDDD'],
  'Asia/Macau': ['+853-DDDD-DDDD'],
  'Asia/Magadan': ['+7(DDD)DDD-DD-DD'],
  'Asia/Makassar': ['+62(8DD)DDD-DDDD', '+62-DD-DDD-DD', '+62-DD-DDD-DDD', '+62-DD-DDD-DDDD', '+62(8DD)DDD-DDD', '+62(8DD)DDD-DD-DDD'],
  'Asia/Manila': ['+63(DDD)DDD-DDDD'],
  'Asia/Muscat': ['+968-DD-DDD-DDD'],
  'Asia/Nicosia': ['+357-DD-DDD-DDD'],
  'Asia/Novokuznetsk': ['+7(DDD)DDD-DD-DD'],
  'Asia/Novosibirsk': ['+7(DDD)DDD-DD-DD'],
  'Asia/Omsk': ['+7(DDD)DDD-DD-DD'],
  'Asia/Oral': ['+7(6DD)DDD-DD-DD', '+7(7DD)DDD-DD-DD'],
  'Asia/Phnom_Penh': ['+855-DD-DDD-DDD'],
  'Asia/Pontianak': ['+62(8DD)DDD-DDDD', '+62-DD-DDD-DD', '+62-DD-DDD-DDD', '+62-DD-DDD-DDDD', '+62(8DD)DDD-DDD', '+62(8DD)DDD-DD-DDD'],
  'Asia/Pyongyang': ['+850-191-DDD-DDDD', '+850-DD-DDD-DDD', '+850-DDD-DDDD-DDD', '+850-DDD-DDD', '+850-DDDD-DDDD', '+850-DDDD-DDDDDDD'],
  'Asia/Qatar': ['+974-DDDD-DDDD', '+973-DDDD-DDDD'],
  'Asia/Qostanay': ['+7(6DD)DDD-DD-DD', '+7(7DD)DDD-DD-DD'],
  'Asia/Qyzylorda': ['+7(6DD)DDD-DD-DD', '+7(7DD)DDD-DD-DD'],
  'Asia/Riyadh': ['+966-5-DDDD-DDDD', '+966-D-DDD-DDDD', '+672-1DD-DDD', '+965-DDDD-DDDD', '+967-DDD-DDD-DDD', '+967-D-DDD-DDD', '+967-DD-DDD-DDD'],
  'Asia/Sakhalin': ['+7(DDD)DDD-DD-DD'],
  'Asia/Samarkand': ['+998-DD-DDD-DDDD'],
  'Asia/Seoul': ['+82-DD-DDD-DDDD'],
  'Asia/Shanghai': ['+86(DDD)DDDD-DDDD', '+86(DDD)DDDD-DDD', '+86-DD-DDDDD-DDDDD'],
  'Asia/Singapore': ['+65-DDDD-DDDD', '+60-DD-DDD-DDDD', '+60(DDD)DDD-DDD', '+60-DD-DDD-DDD', '+60-D-DDD-DDD'],
  'Asia/Srednekolymsk': ['+7(DDD)DDD-DD-DD'],
  'Asia/Taipei': ['+886-D-DDDD-DDDD', '+886-DDDD-DDDD'],
  'Asia/Tashkent': ['+998-DD-DDD-DDDD'],
  'Asia/Tbilisi': ['+995(DDD)DDD-DDD'],
  'Asia/Tehran': ['+98(DDD)DDD-DDDD'],
  'Asia/Thimphu': ['+975-17-DDD-DDD', '+975-D-DDD-DDD'],
  'Asia/Tokyo': ['+81-DD-DDDD-DDDD', '+81(DDD)DDD-DDD'],
  'Asia/Tomsk': ['+7(DDD)DDD-DD-DD'],
  'Asia/Ulaanbaatar': ['+976-DD-DD-DDDD'],
  'Asia/Urumqi': ['+86(DDD)DDDD-DDDD', '+86(DDD)DDDD-DDD', '+86-DD-DDDDD-DDDDD'],
  'Asia/Ust-Nera': ['+7(DDD)DDD-DD-DD'],
  'Asia/Vientiane': ['+856(20DD)DDD-DDD', '+856-DD-DDD-DDD'],
  'Asia/Vladivostok': ['+7(DDD)DDD-DD-DD'],
  'Asia/Yakutsk': ['+7(DDD)DDD-DD-DD'],
  'Asia/Yangon': ['+95-DD-DDD-DDD', '+95-D-DDD-DDD', '+95-DDD-DDD'],
  'Asia/Yekaterinburg': ['+7(DDD)DDD-DD-DD'],
  'Asia/Yerevan': ['+374-DD-DDD-DDD'],
  'Atlantic/Azores': ['+351-DD-DDD-DDDD'],
  'Atlantic/Bermuda': ['+1(441)DDD-DDDD'],
  'Atlantic/Canary': ['+34(DDD)DDD-DDD'],
  'Atlantic/Cape_Verde': ['+238(DDD)DD-DD'],
  'Atlantic/Faroe': ['+298-DDD-DDD'],
  'Atlantic/Madeira': ['+351-DD-DDD-DDDD'],
  'Atlantic/Reykjavik': ['+354-DDD-DDDD'],
  'Atlantic/St_Helena': ['+290-DDDD', '+290-DDDD'],
  'Atlantic/Stanley': ['+500-DDDDD'],
  'Australia/Adelaide': ['+61-D-DDDD-DDDD'],
  'Australia/Brisbane': ['+61-D-DDDD-DDDD'],
  'Australia/Broken_Hill': ['+61-D-DDDD-DDDD'],
  'Australia/Darwin': ['+61-D-DDDD-DDDD'],
  'Australia/Eucla': ['+61-D-DDDD-DDDD'],
  'Australia/Hobart': ['+61-D-DDDD-DDDD'],
  'Australia/Lindeman': ['+61-D-DDDD-DDDD'],
  'Australia/Lord_Howe': ['+61-D-DDDD-DDDD'],
  'Australia/Melbourne': ['+61-D-DDDD-DDDD'],
  'Australia/Perth': ['+61-D-DDDD-DDDD'],
  'Australia/Sydney': ['+61-D-DDDD-DDDD'],
  'Canada/Eastern': ['+1(DDD)DDD-DDDD'],
  'Europe/Amsterdam': ['+31-DD-DDD-DDDD'],
  'Europe/Andorra': ['+376-DDD-DDD'],
  'Europe/Astrakhan': ['+7(DDD)DDD-DD-DD'],
  'Europe/Athens': ['+30(DDD)DDD-DDDD'],
  'Europe/Belgrade': ['+381-DD-DDD-DDDD', '+387-DD-DDDDD', '+387-DD-DDDD', '+385-DD-DDD-DDD', '+382-DD-DDD-DDD', '+389-DD-DDD-DDD', '+386-DD-DDD-DDD'],
  'Europe/Berlin': ['+49(DD)DDD-DDDD', '+49(DDD)DDD-DDDD', '+49(DDD)DD-DDDD', '+49(DDD)DD-DDD', '+49(DDD)DD-DD', '+49-DDD-DDD'],
  'Europe/Bratislava': ['+421(DDD)DDD-DDD'],
  'Europe/Brussels': ['+32(DDD)DDD-DDD'],
  'Europe/Bucharest': ['+40-DD-DDD-DDDD'],
  'Europe/Budapest': ['+36(DDD)DDD-DDD'],
  'Europe/Busingen': ['+49(DD)DDD-DDDD', '+49(DDD)DDD-DDDD', '+49(DDD)DD-DDDD', '+49(DDD)DD-DDD', '+49(DDD)DD-DD', '+49-DDD-DDD'],
  'Europe/Chisinau': ['+373-DDDD-DDDD'],
  'Europe/Copenhagen': ['+45-DD-DD-DD-DD'],
  'Europe/Dublin': ['+353(DDD)DDD-DDD'],
  'Europe/Gibraltar': ['+350-DDD-DDDDD'],
  'Europe/Helsinki': ['+358(DDD)DDD-DD-DD'],
  'Europe/Istanbul': ['+90(DDD)DDD-DDDD'],
  'Europe/Kaliningrad': ['+7(DDD)DDD-DD-DD'],
  'Europe/Kiev': ['+380(DD)DDD-DD-DD'],
  'Europe/Kirov': ['+7(DDD)DDD-DD-DD'],
  'Europe/Lisbon': ['+351-DD-DDD-DDDD'],
  'Europe/Ljubljana': ['+386-DD-DDD-DDD'],
  'Europe/London': ['+44-DD-DDDD-DDDD', 'DDDD-DDD-DDD', 'DDDD-DDD-DDDD'],
  'Europe/Luxembourg': ['+352(DDD)DDD-DDD'],
  'Europe/Madrid': ['+34(DDD)DDD-DDD'],
  'Europe/Malta': ['+356-DDDD-DDDD'],
  'Europe/Minsk': ['+375(DD)DDD-DD-DD'],
  'Europe/Monaco': ['+377(DDD)DDD-DDD', '+377-DD-DDD-DDD'],
  'Europe/Moscow': ['+7(DDD)DDD-DD-DD'],
  'Europe/Oslo': ['+47(DDD)DD-DDD'],
  'Europe/Paris': ['+262-DDDDD-DDDD', '+33(DDD)DDD-DDD', '+508-DD-DDDD', '+590(DDD)DDD-DDD'],
  'Europe/Podgorica': ['+382-DD-DDD-DDD'],
  'Europe/Prague': ['+420(DDD)DDD-DDD', '+421(DDD)DDD-DDD'],
  'Europe/Riga': ['+371-DD-DDD-DDD'],
  'Europe/Rome': ['+39(DDD)DDDD-DDD', '+39(DDD)DDDD-DDDD', '+378-DDDD-DDDDDD', '+39-6-698-DDDDD'],
  'Europe/Samara': ['+7(DDD)DDD-DD-DD'],
  'Europe/San_Marino': ['+378-DDDD-DDDDDD'],
  'Europe/Sarajevo': ['+387-DD-DDDDD', '+387-DD-DDDD'],
  'Europe/Saratov': ['+7(DDD)DDD-DD-DD'],
  'Europe/Simferopol': ['+7(DDD)DDD-DD-DD', '+380(DD)DDD-DD-DD'],
  'Europe/Skopje': ['+389-DD-DDD-DDD'],
  'Europe/Sofia': ['+359(DDD)DDD-DDD'],
  'Europe/Stockholm': ['+46-DD-DDD-DDDD'],
  'Europe/Tallinn': ['+372-DDDD-DDDD', '+372-DDD-DDDD'],
  'Europe/Tirane': ['+355(DDD)DDD-DDD'],
  'Europe/Ulyanovsk': ['+7(DDD)DDD-DD-DD'],
  'Europe/Uzhgorod': ['+380(DD)DDD-DD-DD'],
  'Europe/Vaduz': ['+423(DDD)DDD-DDDD'],
  'Europe/Vatican': ['+39(DDD)DDDD-DDD', '+39(DDD)DDDD-DDDD', '+378-DDDD-DDDDDD', '+39-6-698-DDDDD'],
  'Europe/Vienna': ['+43(DDD)DDD-DDDD'],
  'Europe/Vilnius': ['+370(DDD)DD-DDD'],
  'Europe/Volgograd': ['+7(DDD)DDD-DD-DD'],
  'Europe/Warsaw': ['+48(DDD)DDD-DDD'],
  'Europe/Zagreb': ['+385-DD-DDD-DDD'],
  'Europe/Zaporozhye': ['+380(DD)DDD-DD-DD'],
  'Europe/Zurich': ['+41-DD-DDD-DDDD', '+49(DD)DDD-DDDD', '+49(DDD)DDD-DDDD', '+49(DDD)DD-DDDD', '+49(DDD)DD-DDD', '+49(DDD)DD-DD', '+49-DDD-DDD', '+423(DDD)DDD-DDDD'],
  'Indian/Antananarivo': ['+261-DD-DD-DDDDD'],
  'Indian/Chagos': ['+246-DDD-DDDD'],
  'Indian/Comoro': ['+269-DD-DDDDD'],
  'Indian/Mahe': ['+248-D-DDD-DDD'],
  'Indian/Maldives': ['+960-DDD-DDDD'],
  'Indian/Mauritius': ['+230-DDD-DDDD'],
  'Indian/Reunion': ['+262-DDDDD-DDDD'],
  'NZ': ['+64(DDD)DDD-DDD', '+64-DD-DDD-DDD', '+64(DDD)DDD-DDDD'],
  'Pacific/Apia': ['+685-DD-DDDD'],
  'Pacific/Auckland': ['+64(DDD)DDD-DDD', '+64-DD-DDD-DDD', '+64(DDD)DDD-DDDD', '+672-1DD-DDD'],
  'Pacific/Bougainville': ['+675(DDD)DD-DDD'],
  'Pacific/Chatham': ['+64(DDD)DDD-DDD', '+64-DD-DDD-DDD', '+64(DDD)DDD-DDDD'],
  'Pacific/Chuuk': ['+691-DDD-DDDD'],
  'Pacific/Easter': ['+56-D-DDDD-DDDD'],
  'Pacific/Efate': ['+678-DD-DDDDD', '+678-DDDDD'],
  'Pacific/Fakaofo': ['+690-DDDD'],
  'Pacific/Fiji': ['+679-DD-DDDDD'],
  'Pacific/Funafuti': ['+688-90DD', '+688-2DD'],
  'Pacific/Galapagos': ['+593-DD-DDD-DDDD', '+593-D-DDD-DDDD'],
  'Pacific/Gambier': ['+689-DD-DD-DD'],
  'Pacific/Guadalcanal': ['+677-DDD-DDDD', '+677-DDDDD'],
  'Pacific/Guam': ['+1(671)DDD-DDDD', '+1(670)DDD-DDDD'],
  'Pacific/Honolulu': ['+1(DDD)DDD-DDDD'],
  'Pacific/Kanton': ['+686-DD-DDD'],
  'Pacific/Kiritimati': ['+686-DD-DDD'],
  'Pacific/Kosrae': ['+691-DDD-DDDD'],
  'Pacific/Kwajalein': ['+692-DDD-DDDD'],
  'Pacific/Majuro': ['+692-DDD-DDDD'],
  'Pacific/Marquesas': ['+689-DD-DD-DD'],
  'Pacific/Nauru': ['+674-DDD-DDDD'],
  'Pacific/Niue': ['+683-DDDD'],
  'Pacific/Norfolk': ['+672-3DD-DDD'],
  'Pacific/Noumea': ['+687-DD-DDDD'],
  'Pacific/Pago_Pago': ['+1(684)DDD-DDDD'],
  'Pacific/Palau': ['+680-DDD-DDDD'],
  'Pacific/Pohnpei': ['+691-DDD-DDDD'],
  'Pacific/Port_Moresby': ['+675(DDD)DD-DDD', '+672-1DD-DDD'],
  'Pacific/Rarotonga': ['+682-DD-DDD'],
  'Pacific/Saipan': ['+1(670)DDD-DDDD'],
  'Pacific/Samoa': ['+685-DD-DDDD'],
  'Pacific/Tahiti': ['+689-DD-DD-DD'],
  'Pacific/Tarawa': ['+686-DD-DDD'],
  'Pacific/Tongatapu': ['+676-DDDDD'],
  'Pacific/Wallis': ['+681-DD-DDDD'],
  'Singapore': ['+65-DDDD-DDDD'],
  'US/Arizona': ['+1(DDD)DDD-DDDD'],
  'US/Hawaii': ['+1(DDD)DDD-DDDD'],
  'US/Samoa': ['+685-DD-DDDD']
};

/**
 * Service for modifying phone masks before they are applied to the input.
 * Can be overridden to provide custom mask modification logic.
 */
let PhoneMaskModifierService = /*#__PURE__*/(() => {
  class PhoneMaskModifierService {
    /**
     * Modifies phone masks organized by timezone.
     * Default implementation returns the masks object as-is without modifications.
     * Override this method to implement custom mask modification logic.
     *
     * @param masks - Object with timezone keys and mask arrays as values
     * @returns Modified object with the same structure
     */
    modifyMasks(masks) {
      return masks;
    }
    static {
      this.ɵfac = function PhoneMaskModifierService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PhoneMaskModifierService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PhoneMaskModifierService,
        factory: PhoneMaskModifierService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PhoneMaskModifierService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PhoneInputComponent = /*#__PURE__*/(() => {
  class PhoneInputComponent {
    static {
      this.nextId = 0;
    }
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      this._disabled = coerceBooleanProperty(value);
      this._disabled ? this.formControl.disable() : this.formControl.enable();
      this.stateChanges.next();
    }
    get required() {
      return this._required;
    }
    set required(value) {
      this._required = coerceBooleanProperty(value);
      this.stateChanges.next();
    }
    get value() {
      if (this.formControl.getRawValue()) {
        this.emitMaskedPhone();
        let phoneWithoutMask = this.formControl.getRawValue().replace(/[^\d+]/g, '');
        if (phoneWithoutMask.slice(0, 1) === '0') {
          phoneWithoutMask = '+44' + phoneWithoutMask.slice(1);
        }
        return phoneWithoutMask;
      } else {
        return null;
      }
    }
    set value(value) {
      this.formControl.setValue(value || '');
      this.onValidationChange();
      this.stateChanges.next();
    }
    get placeholder() {
      return this.phonePlaceholder;
    }
    set placeholder(value) {
      this._placeholder = value;
      this.stateChanges.next();
    }
    get autocomplete() {
      return this._autocomplete;
    }
    set autocomplete(value) {
      this._autocomplete = value;
      this.stateChanges.next();
    }
    get errorState() {
      if (!this.formControl) {
        return false;
      }
      return this.formControl.invalid && (this.isError || this.touched);
    }
    get empty() {
      const value = this.formControl.value;
      return !value;
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    constructor(elementRef, phoneMaskModifier) {
      this.elementRef = elementRef;
      this.phoneMaskModifier = phoneMaskModifier;
      this._disabled = false;
      this._required = false;
      this._autocomplete = 'on';
      this._placeholder = '';
      this.userAgent = window.navigator.userAgent;
      this.savedPhoneMask = localStorage.getItem('phoneMask');
      this.hasCode = false;
      this.maskedPhone = new EventEmitter();
      this.id = `phone-input-${++PhoneInputComponent.nextId}`;
      this.formControl = new FormControl('', {
        nonNullable: true
      });
      this.stateChanges = new Subject();
      this.focused = false;
      this.touched = false;
      this.controlType = 'phone-input';
      this.mask = [];
      this.onChange = _ => {};
      this.onTouched = () => {};
      this.onValidationChange = () => {};
    }
    ngOnInit() {
      this.masksByTimezones = this.phoneMaskModifier.modifyMasks(masksByTimezones);
      this.phoneMasksValues = Object.values(this.masksByTimezones ?? masksByTimezones);
      this.mask = this.phoneMask;
      this.setMaskParams();
    }
    ngOnChanges() {
      if (this.isError || this.touched) {
        this.stateChanges.next();
      }
    }
    ngOnDestroy() {
      this.stateChanges.complete();
      clearTimeout(this.autofillTimeout);
    }
    phoneInputValidator() {
      return control => {
        if (control.value) {
          if (!this.hasCode) {
            return {
              phoneCodeError: {
                valid: false
              }
            };
          } else if (control.value.length < this.phoneWithMaskLength) {
            if (control.value.length < this.phoneLength && this.mask.length === 1) {
              return {
                singleMinLengthError: {
                  currentLength: control.value.length,
                  minLength: this.phoneLength
                }
              };
            } else if (control.value.length < this.phoneLength && this.mask.length !== 1) {
              return {
                multipleMinLengthError: {
                  currentLength: control.value.length,
                  minLength: this.phoneLength
                }
              };
            }
          }
          return null;
        }
        return null;
      };
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    registerOnValidatorChange(fn) {
      this.onValidationChange = fn;
    }
    validate(control) {
      if (!control.value) {
        return this.phoneInputValidator()(control);
      } else {
        this.checkCode(control);
      }
      if (control.value?.length !== this.phoneNumbers?.length || !this.hasCode) {
        return this.phoneInputValidator()(control);
      } else {
        return null;
      }
    }
    checkCode(control) {
      if (this.timeZone === 'Europe/London') {
        this.hasCode = true;
        return;
      }
      this.hasCode = this.phoneMasksValues.some(phoneArray => {
        return phoneArray.some(item => {
          item = item.replace(/[-D()]/g, '');
          return item !== '' && control.value.includes(item);
        });
      });
    }
    writeValue(value) {
      this.value = value;
      if (value && value !== '') {
        this.emitMaskedPhone();
        if (this.timeZone !== 'Europe/London') {
          this.updateAccordingCache();
        }
        this.touched = true;
      }
    }
    checkListOfMasks() {
      if (this.timeZone === 'Europe/London') {
        this.setValidators();
        return;
      }
      const phone = this.formControl.getRawValue();
      this.updateMask(phone);
      this.setValidators();
    }
    updateAccordingCache() {
      this.mask = [];
      if (this.savedPhoneMask != null) {
        this.mask.push(this.savedPhoneMask);
      }
    }
    updateMask(phone) {
      if (phone === '' && this.savedPhoneMask) {
        this.updateAccordingCache();
        return;
      }
      this.phoneMasksValues.map(phoneArray => {
        phoneArray.forEach(item => {
          if (item.indexOf(phone) > -1) {
            this.mask = [];
            phoneArray.map(el => {
              this.mask.push(el.replace(/\d/g, 'D'));
              this.phoneCodeArr = el.match(/\d/g);
            });
          }
          this.setMaskParams();
        });
      });
    }
    setMaskParams() {
      this.mask.sort(this.compareMasks);
      const shortestMask = this.mask[0];
      localStorage.setItem('phoneMask', shortestMask);
      this.phoneWithMaskLength = shortestMask.length;
      this.phoneNumbers = shortestMask.replace(/[()\\-]/g, '').replace(/D/g, '0');
      this.phoneLength = this.phoneNumbers.length;
    }
    compareMasks(a, b) {
      return a.length - b.length;
    }
    setValidators() {
      this.formControl.setValidators([Validators.required, Validators.minLength(this.phoneWithMaskLength), this.phoneInputValidator()]);
    }
    emitMaskedPhone() {
      let phone = this.formControl.getRawValue();
      if (this.timeZone === 'Europe/London' && phone.slice(0, 1) === '0') {
        phone = '+44-' + phone.slice(1);
      }
      this.maskedPhone.emit(phone);
    }
    onFocusIn() {
      if (!this.focused) {
        this.focused = true;
        this.stateChanges.next();
      }
    }
    onFocusOut(event) {
      if (!this.elementRef.nativeElement.contains(event.relatedTarget)) {
        this.touched = true;
        this.focused = false;
        this.onTouched();
        this.stateChanges.next();
        this.formControl.updateValueAndValidity();
      }
    }
    setDescribedByIds(ids) {
      const controlElement = this.elementRef.nativeElement.querySelector('input');
      controlElement.setAttribute('aria-describedby', ids.join(' '));
    }
    onContainerClick(event) {
      if (event.target.tagName.toLowerCase() !== 'input') {
        this.elementRef.nativeElement.querySelector('input')?.focus();
      }
    }
    onInput() {
      if (this.userAgent.match(/iPad/i) || this.userAgent.match(/iPhone/i)) {
        clearTimeout(this.autofillTimeout);
        this.autofillTimeout = setTimeout(() => {
          const autofilledInput = this.elementRef.nativeElement.querySelector('.masked-phone-input:-webkit-autofill');
          if (!this.isMask && autofilledInput) {
            this.value = this.phoneCode + this.value;
            this.onChange(this.value);
          }
          this.onChange(this.value);
          this.stateChanges.next();
          this.formControl.updateValueAndValidity();
        }, 100);
      } else {
        this.onChange(this.value);
      }
    }
    get isMask() {
      return this.value ? this.value.includes(this.phoneCode) : false;
    }
    get timeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    get phoneMask() {
      if (this.timeZone) {
        this.timeZoneMask = this.masksByTimezones[this.timeZone];
      }
      if (this.timeZoneMask) {
        this.maskArr = this.timeZoneMask;
        this.phoneCodeArr = this.timeZoneMask.toString().match(/\d/g);
        return this.timeZoneMask.map(item => item.replace(/\d/g, 'D'));
      } else {
        const defaultMask = '+D(DDD)DDD-DD-DD';
        this.maskArr = [...[defaultMask]];
        this.phoneCodeArr = ['+7'];
        return this.maskArr;
      }
    }
    get phonePlaceholder() {
      this.maskArr.sort((a, b) => {
        return b.length - a.length;
      });
      if (this.timeZone === 'Europe/London') {
        return '';
      }
      return this.maskArr[0].replace(/D/g, '0');
    }
    get phoneCode() {
      if (this.phoneCodeArr) {
        return '+' + this.phoneCodeArr.join('');
      }
      return '';
    }
    static {
      this.ɵfac = function PhoneInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PhoneInputComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PhoneMaskModifierService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PhoneInputComponent,
        selectors: [["ecl-phone-input"]],
        viewQuery: function PhoneInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.phoneMatInput = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function PhoneInputComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵdomProperty("id", ctx.id);
          }
        },
        inputs: {
          disabled: "disabled",
          required: "required",
          value: "value",
          placeholder: "placeholder",
          autocomplete: "autocomplete",
          isError: "isError",
          readonly: "readonly"
        },
        outputs: {
          maskedPhone: "maskedPhone"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: PhoneInputComponent
        }, {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => PhoneInputComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => PhoneInputComponent),
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 6,
        consts: [["phone", ""], ["name", "phone", "type", "tel", "data-testid", "phone", "matInput", "", 1, "mat-input-element", "masked-phone-input", 3, "focusin", "focusout", "input", "ngModelChange", "required", "formControl", "angularFormsMask", "placeholder", "readonly", "autocomplete"]],
        template: function PhoneInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "input", 1, 0);
            i0.ɵɵlistener("focusin", function PhoneInputComponent_Template_input_focusin_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusIn());
            })("focusout", function PhoneInputComponent_Template_input_focusout_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusOut($event));
            })("input", function PhoneInputComponent_Template_input_input_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInput());
            })("ngModelChange", function PhoneInputComponent_Template_input_ngModelChange_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.checkListOfMasks());
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("required", ctx.required)("formControl", ctx.formControl)("angularFormsMask", ctx.mask)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("autocomplete", ctx.autocomplete);
          }
        },
        dependencies: [ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.FormControlDirective, MatInputModule, i3.MatInput, AngularFormsMaskDirective],
        encapsulation: 2
      });
    }
  }
  return PhoneInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { PhoneInputComponent, PhoneMaskModifierService, masksByTimezones };
